import React, { useEffect, useRef } from "react";

const SuccessModal = ({ isOpen, onClose, actionMassage }) => {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    // Automatically focus the Close button on modal open
    closeButtonRef.current?.focus();
  }, []);

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     onClose();
  //   }
  // };
  if (!isOpen) return null;
  console.log("isOpen", isOpen);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-30" />
      <div className="relative z-60 w-full max-w-md bg-white rounded-lg shadow-xl">
        <div
          // onKeyDown={handleKeyDown}
          className="p-6 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-2">Success!</h3>
          <p className="mb-4">{actionMassage}</p>
          <button
            ref={closeButtonRef}
            onClick={onClose}
            className="w-1/3 text-center bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
